﻿//@ts-nocheck
export const JobTileFunctions = () => {
    if (document.body.classList.contains('page-redesign')) return

    const Jobtiles: NodeListOf<HTMLElement> = document.querySelectorAll(".attrax-vacancy-tile");

    Jobtiles.forEach((JobTile) => {
        setBrandLogo(JobTile);
        addtionalSection(JobTile);
    });
}

 function setBrandLogo(JobTile: HTMLElement) {
    const brandLogos = [
        {
            class: "attrax-vacancy-tile__option-brand--independent-local",
            image: "mab-logo.png",
            tileClass: "attrax-vacancy-tile--brand--independent-local",
        }, {
            class: "attrax-vacancy-tile__option-brand--all-bar-one",
            image: "all-bar-one-logo-gold.png",
            tileClass: "attrax-vacancy-tile--brand-all-bar-one",
        }, {
        class: "attrax-vacancy-tile__option-brand--miller-carter",
        image: "Miller-&-Carter-Logo.png",
        tileClass: "attrax-vacancy-tile--brand-miller-carter",
    }, {
        class: "attrax-vacancy-tile__option-brand--ember-inns",
        image: "vintage-innsweb.png",
        tileClass: "attrax-vacancy-tile--brand--ember-inns",
        }, {
        class: "attrax-vacancy-tile__option-brand--castle",
        image: "castle-logo-cmyk-full.png",
        tileClass: "attrax-vacancy-tile--brand--castle",
        }, {
        class: "attrax-vacancy-tile__option-brand--harvester",
        image: "harvester-logo.png",
        tileClass: "attrax-vacancy-tile--brand--harvester",
        }, {
        class: "attrax-vacancy-tile__option-brand--toby-carvery",
        image: "toby.svg",
        tileClass: "attrax-vacancy-tile--brand--toby-carvery",
        }, {
        class: "attrax-vacancy-tile__option-brand--son-of-steak",
        image: "mab-logo.png",
        tileClass: "attrax-vacancy-tile--brand--son-of-steak",
        }, {
        class: "attrax-vacancy-tile__option-brand--neighbourhood-pubs",
        image: "mab-logo.png",
        tileClass: "attrax-vacancy-tile--brand--neighbourhood-pubs",
        }, {
        class: "attrax-vacancy-tile__option-brand--great-british-carvery",
        image: "mab-logo.png",
        tileClass: "attrax-vacancy-tile--brand--great-british-carvery",
        }, {
        class: "attrax-vacancy-tile__option-brand--chicken-society",
        image: "TheChickenSociety_Logo.png",
        tileClass: "attrax-vacancy-tile--brand--chicken-society",
        }, {
        class: "attrax-vacancy-tile__option-brand--browns",
        image: "browns-logo.png",
        tileClass: "attrax-vacancy-tile--brand--browns",
        }, {
        class: "attrax-vacancy-tile__option-brand--all-inns",
        image: "mab-logo.png",
        tileClass: "attrax-vacancy-tile--brand--all-inns",
        }, {
        class: "attrax-vacancy-tile__option-brand--crown-carveries",
        image: "crown-logo.png",
        tileClass: "attrax-vacancy-tile--brand--crown-carveries",
        }, {
        class: "attrax-vacancy-tile__option-brand--nicholsons",
        image: "nicholson-s-logo-colour.png",
        tileClass: "attrax-vacancy-tile--brand--nicholsons",
        }, {
        class: "attrax-vacancy-tile__option-brand--oak-tree-pubs",
        image: "oaktree-logo.png",
        tileClass: "attrax-vacancy-tile--brand--oak-tree-pubs",
        }, {
        class: "attrax-vacancy-tile__option-brand--premium-country-pubs",
        image: "pcp-logo.png",
        tileClass: "attrax-vacancy-tile--brand--premium-country-pubs",
        }, {
        class: "attrax-vacancy-tile__option-brand--stonehouse-pizza-carvery",
        image: "stonehouse-logo-small.png",
        tileClass: "attrax-vacancy-tile--brand--stonehouse-pizza-carvery",
        }, {
        class: "attrax-vacancy-tile__option-brand--oneills",
        image: "o-neill-s-logo-activation-colour.png",
        tileClass: "attrax-vacancy-tile--brand--oneills",
        }, {
        class: "attrax-vacancy-tile__option-brand--sizzling-pub-grill",
        image: "sizzling.svg",
        tileClass: "attrax-vacancy-tile--brand--sizzling-pub-grill",
        }, {
        class: "attrax-vacancy-tile__option-brand--vintage",
        image: "vintage-inns-web.png",
        tileClass: "attrax-vacancy-tile--brand--vintage",
        }, {
        class: "attrax-vacancy-tile__option-brand--mitchells-butlers",
        image: "mab-logo.png",
        tileClass: "attrax-vacancy-tile--brand--mitchells-butlers",
        }, {
        class: "attrax-vacancy-tile__option-brand--son-of-steak",
        image: "sonofsteak.jpg",
        tileClass: "attrax-vacancy-tile--brand--son-of-steak",
        }, {
        class: "attrax-vacancy-tile__option-brand--ibis-hotels",
        image: "ibis-logo.png",
        tileClass: "attrax-vacancy-tile--brand--ibis-hotels",
        }, {
        class: "attrax-vacancy-tile__option-brand--orleans",
        image: "orleans-logo.png",
        tileClass: "attrax-vacancy-tile--brand--orleans",
        }, {
        class: "attrax-vacancy-tile__option-brand--ego",
        image: "ego-logo.png",
        tileClass: "attrax-vacancy-tile--brand--ego",
        },
    ]

        const brandOption: HTMLElement = JobTile.querySelector(".attrax-vacancy-tile__option-brand");

        if (!brandOption) return;

        brandLogos.forEach((brand) => {
            if (
                brandOption.classList.contains(brand.class)
            ) {
                setBrandClasses(brand.image, brand.tileClass, JobTile, brandOption);
            }
        });


}

 export function setBrandClasses(image, tileClass, JobTile: HTMLElement, brandOption: HTMLElement) {
    if (!JobTile || !brandOption) return;  
    brandOption.style.background = getBrandImage(image);
        JobTile.classList.add(tileClass);

}

const getBrandImage = (file): string =>
    "url(/Blob/img/brands/" + file + ")";

export function addtionalSection(JobTile: HTMLElement) {
    const expandbtns: NodeListOf<Element> = JobTile.querySelectorAll(
        ".attrax-vacancy-tile__expand-btn"
    );

    expandbtns.forEach((expand) => {
        const parent = expand.closest(".attrax-vacancy-tile");
        const divider = document.createElement("div");
        divider.classList.add("attrax-vacancy-tile__divider");
        parent.append(divider);

        expand.addEventListener("click", (e) => {
            e.stopPropagation();
            parent.classList.toggle("open");
        });
    });
};